// tenantType comes from the JWT (see LoginPage) and is exposed via useUserRole().
// It gates which menu items a practice type (GP vs CONSULT) can see, the same
// way `roles` gates menu items per user role.
export const TENANT_TYPES = {
  GP: "GP",
  CONSULT: "CONSULT",
};

// An item with no `tenantTypes` (or an empty array) is visible to every tenant
// type — same convention as an empty `roles` array. An unknown/missing
// tenantType fails open (item stays visible) so tenants without the claim
// aren't unexpectedly locked out of existing menu items.
export const isTenantTypeAllowed = (allowedTenantTypes, tenantType) => {
  if (!allowedTenantTypes || allowedTenantTypes.length === 0) return true;
  if (!tenantType) return true;

  return allowedTenantTypes.includes(tenantType.toUpperCase());
};
